"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergePassDesign = mergePassDesign;
function isPlainObject(v) {
    return typeof v === 'object' && v !== null && !Array.isArray(v);
}
function mergeValue(base, override) {
    if (isPlainObject(base) && isPlainObject(override)) {
        const out = { ...base };
        for (const key of Object.keys(override)) {
            const ov = override[key];
            if (ov === undefined)
                continue; // never write explicit undefined
            if (ov === null) {
                delete out[key]; // explicit delete sentinel — drop the key entirely
                continue;
            }
            out[key] = key in base ? mergeValue(base[key], ov) : ov;
        }
        return out;
    }
    // arrays + scalars: override replaces
    return override;
}
function mergePassDesign(base, override) {
    return mergeValue(base, override);
}
//# sourceMappingURL=mergePassDesign.js.map